import { RouteConfig } from 'vue-router'
import { requireAuthAndLocation } from '../../auth'

const GiftCardsApp = () => import('@/pmd/pages/payments/gift-cards/GiftCards.vue')
const CreateGiftCardsApp = () => import('@/pmd/pages/payments/gift-cards/CreateGiftCards.vue')
const EditGiftCardsApp = () => import('@/pmd/pages/payments/gift-cards/EditGiftCards.vue')
const SendGiftCardsApp = () => import('@/pmd/pages/payments/gift-cards/SendGiftCards.vue')
const OrderDetailsGiftCardsApp = () => import('@/pmd/pages/payments/gift-cards/OrderDetails.vue')
const SellGiftCardsApp = () => import('@/pmd/pages/payments/gift-cards/SellGiftCards.vue')

export const GiftCardsRoute: RouteConfig[] = [
  {
    path: 'payments/gift-cards',
    name: 'gift-cards',
    component: GiftCardsApp,
    beforeEnter: requireAuthAndLocation,
    children: [],
  },
  {
    path: 'payments/gift-cards/create',
    name: 'create-gift-cards',
    component: CreateGiftCardsApp,
    beforeEnter: requireAuthAndLocation,
    children: [],
    meta:{
      hideSideBar: false,
      hideTopBar: true,
    }
  },
  {
    path: 'payments/gift-cards/edit/:id',
    name: 'edit-gift-cards',
    component: EditGiftCardsApp,
    beforeEnter: requireAuthAndLocation,
    children: [],
    meta:{
      hideSideBar: false,
      hideTopBar: true,
    }
  },
  {
    path: 'payments/gift-cards/send/:id',
    name: 'send-gift-cards',
    component: SendGiftCardsApp,
    beforeEnter: requireAuthAndLocation,
    children: [],
    meta:{
      hideSideBar: false,
      hideTopBar: true,
    }
  },
  {
    path: 'payments/gift-cards/order/:id',
    name: 'order-details-gift-cards',
    component: OrderDetailsGiftCardsApp,
    beforeEnter: requireAuthAndLocation,
    children: [],
    meta:{
      hideSideBar: false,
      hideTopBar: true,
    }
  },
  {
    path: 'payments/gift-cards/sell/:id',
    name: 'sell-gift-cards',
    component: SellGiftCardsApp,
    beforeEnter: requireAuthAndLocation,
    children: [],
    meta:{
      hideSideBar: false,
      hideTopBar: true,
    }
  },
]
